import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs";
import { environment } from "src/environments/environment";
import { AppareilMesure } from "../domain/appareil-meure";
import { CoreData } from "../tools/core-data/core-data";
import { mapper } from "../tools/mapping/mapper";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { MetrologieDTO as AppareilMesureDTO } from "./dto/metrologie.dto";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
    providedIn: 'root',
})
export class AppareilMesureService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/appareilmesure`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    getMyDevicesInfo() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getMyDevicesInfo')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: AppareilMesureDTO) => {
                return mapper.map(response, AppareilMesureDTO, AppareilMesure);         
            }));
    }

    setMyDevicesInfo(metro: AppareilMesure) {
        this.loadingTask.activateLoading();
        const dto = JSON.stringify(metro);
        return this.http.put(`${this.serviceUrl}`, dto, this.generateHeader()).pipe(
            catchError(this.handleError<any>('setMyDevicesInfo')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }
}